export const POST_LOGIN_REDIRECT_STORAGE_KEY = 'deltrans:postLoginRedirect'

const PUBLIC_PATH_PREFIXES = [
  '/login',
  '/forgot-password',
  '/reset-password',
  '/two-factor',
]

function pathnameOf(target: string): string {
  try {
    return new URL(target, 'http://deltrans.local').pathname
  } catch {
    return ''
  }
}

/** Same-origin relative paths only; excludes auth pages to avoid redirect loops. */
export function isSafePostLoginRedirect(target: string): boolean {
  if (!target || typeof target !== 'string') return false
  const t = target.trim()
  if (!t.startsWith('/') || t.startsWith('//')) return false
  const path = pathnameOf(t)
  if (!path) return false
  return !PUBLIC_PATH_PREFIXES.some((p) => path === p || path.startsWith(`${p}/`))
}

export function savePostLoginRedirect(fullPath: string): void {
  if (typeof window === 'undefined') return
  if (!isSafePostLoginRedirect(fullPath)) return
  sessionStorage.setItem(POST_LOGIN_REDIRECT_STORAGE_KEY, fullPath)
}

/** Read without removing (e.g. to detect when the user has reached the saved URL while already authenticated). */
export function peekPostLoginRedirect(): string | null {
  if (typeof window === 'undefined') return null
  const raw = sessionStorage.getItem(POST_LOGIN_REDIRECT_STORAGE_KEY)
  if (!raw || !isSafePostLoginRedirect(raw)) return null
  return raw
}

/** Read and remove stored redirect (call once after successful auth). */
export function consumePostLoginRedirect(): string | null {
  if (typeof window === 'undefined') return null
  const raw = sessionStorage.getItem(POST_LOGIN_REDIRECT_STORAGE_KEY)
  sessionStorage.removeItem(POST_LOGIN_REDIRECT_STORAGE_KEY)
  if (!raw || !isSafePostLoginRedirect(raw)) return null
  return raw
}

export function clearPostLoginRedirect(): void {
  if (typeof window === 'undefined') return
  sessionStorage.removeItem(POST_LOGIN_REDIRECT_STORAGE_KEY)
}
